<template>
  <div>
    <div id="plan"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "plan",
  data() {
    return {
      colorList: ['rgba(89,89,215,1)', 'rgba(192,196,204,1)', 'rgb(65,228,222)', 'rgb(50,184,240)'],
      colorList2: ['rgba(89,89,215,.6)', 'rgba(192,196,204,.6)', 'rgba(65,228,222,.6)', 'rgba(50,184,240,.6)'],
      planCharts: null,
      options: {
        tooltip: {
          trigger: 'item',
        },
        graphic: {
          type: 'text',
          left: '45%',
          top: '35%',
          style: {
            text: null,
            fill: '#fff',
            font: '.9rem "STHeiti", sans-serif',
          }
        },
        title: { // 第一个圆环标题
          text: "应急预案", // 主标题
          textStyle: { // 主标题样式
            color: '#BCCBEF',
            fontSize: '.7rem',
            fontWeight: '500',
          },
          left: '45%',
          top: '45%', // 定位到适合的位置
          subtext: '（个）', // 副标题
          subtextStyle: { // 副标题样式
            color: '#287CE8',
            fontSize: '.6rem',
            fontWeight: '500',
            lineHeight: 5,
          },
          textAlign: 'center'
        },
        series: [
          {
            name: '综合预案',
            type: 'pie',
            radius: ['80%', '90%'],
            emphasis: {
              scale: false,
            },
            label: {
              show: false
            },
            minAngle: 30,//最小角度
            avoidLabelOverlap: false,
            data: []
          }, {
            name: '专项预案',
            type: 'pie',
            minAngle: 30,//最小角度
            radius: ['60%', '83%'],
            emphasis: {
              scale: false,
            },
            label: {
              show: false
            },
            avoidLabelOverlap: false,
            data: [],
            itemStyle: {
              borderWidth: 90,
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.getPlanManagements()
  },
  methods: {
    initCharts() {
      let planCharts = document.getElementById('plan');
      this.planCharts = echarts.init(planCharts);
      this.planCharts.setOption(this.options);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.planCharts.resize();
        });
      });
    },
    getPlanManagements() {
      // 应急预案
      this.$http.get(`/api/getPlanManagementsNumber`).then(res => {
          if (res.status === 200) {
            let dataArr1 = []
            for (let i in res.data) {
              if (res.data[i].title !== '总共') {
                dataArr1.push({
                  value: res.data[i].value,
                  name: res.data[i].title,
                  itemStyle: {
                    color: this.colorList[i - 1],
                  }
                })
              }
              // this.options.series[0].name = res.data[0].title
            }
            let dataArr2 = []
            for (let i in res.data) {
              if (res.data[i].title !== '总共') {
                dataArr2.push({
                  value: res.data[i].value,
                  name: res.data[i].title,
                  itemStyle: {
                    color: this.colorList2[i - 1]
                  }
                })
              }
            }
            this.options.series[0].data = dataArr1
            this.options.series[1].data = dataArr2
            // this.options.graphic.style.text = res.data.data[0].value + '\n' + '总计'
            this.options.graphic.style.text = `${res.data[0].value}`
            this.$nextTick(() => {
              this.initCharts()
            })
          }
        }
      )
    },
  }
}
</script>

<style scoped lang="less">
#plan {
  width: 100%;
  height: 12vh;
  margin-top: 10px;
}
</style>
